<template>
	<div id="apart_main">
		<div class="flex-coloum flex-1 apart_main_top">
			<div class="apart-top flex-row flex-row-between">
				<div class="flex-row cursor_1 t-p-l-25" @click="toBack" style="z-index: 2;">
					<img class="back-img" :src="require('@/assets/image/icon_right.png')">
					<span class="apart-top-title">
						分卷列表
					</span>
				</div>
				<div class="apart-top-title"
					style="position: absolute;left: 0;right: 0;margin: auto;text-align: center;z-index: 1;">
					{{ novelInfo.name }}
				</div>
				<div class="add-btn t-p-r-25" style="z-index: 2;">
					<div v-if="mixinNInfo && mixinUserInfo && mixinNInfo.recall && zsVip()" style="padding: 0 10px;">
						<el-switch v-model="recall" @change="recallChange" :width="140" class="main-el-switch"
							　　active-text="已开启长记忆" 　　inactive-text="已关闭长记忆" />
					</div>
					<el-button size="medium" type="warning" @click="lookSeries">查看分卷</el-button>
					<!-- <div class="add-btn t-p-r-25" @click="handleAdd">
						<img class="add-icon" :src="require('@/assets/image/apart/add.png')">
						<span class="add-text">
							去拆书
						</span>
					</div> -->
				</div>
			</div>

			<div class="apart-list">
				<div class="apart-item" v-for="(item, i) in list" :key="i" @click.stop="look(item, i)">
					<div class="apart-title">
						<span>{{ item.title }}</span>
						<div class="flex-row">
							<div v-if="item.status == 0" class="novel_chapter1_29"></div>
							<div v-if="item.status == 1" class="novel_chapter1_30"></div>
							<div v-if="item.status == 2" class="novel_chapter1_8"></div>
							<span style="font-weight: normal;font-size: 15px;">{{ item.status == 0 ? '未创作' : item.status
								== 1 ? '创作中' : '已完成' }}</span>
						</div>
					</div>
					<div class="apart-content u-line-2">{{ item.content }}</div>
					<div class="apart-info t-m-t-20">
						<span>{{ item.writed }}/{{ item.chapters }}章</span>
						<span class="info-right">
							<span class="list-btn cursor_1" @click.stop="look(item, i)">
								<i class="el-icon-view t-m-r-3"></i>查看大纲
							</span>
							<span class="list-btn cursor_1 t-m-l-10" @click.stop="delChatpterAll(item)">
								<i class="el-icon-brush t-m-r-3" style="transform: rotate(180deg);"></i>清空大纲
							</span>
							<span class="list-btn cursor_1 t-m-l-10" @click.stop="del(i, item.id)">
								<i class="el-icon-delete t-m-r-3"></i>删除分卷
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
		<bottomPage v-if="total" :total="total" @currentNUm="currentNUm" ref="bottompage"></bottomPage>
		<!-- <popup ref="delPopup" @confirm="confirm"></popup> -->
	</div>

</template>

<script>
import { copy } from '@/utils/utils'
import bottomPage from '@/components/bottom_page.vue' //底部分页
import outlineContinuous from '@/components/outline_continuous.vue'
import popup from '@/components/dongeb/popup.vue';
import api from '@/api/api';
import lNApi from '@/api/longNovel';
import { EncryptionUtil } from '@/utils/encrypt'
export default {
	components: {
		bottomPage, outlineContinuous, popup
	},
	data() {
		return {
			chapterTitle: ['分卷', '分卷标题', '分卷内容', '发布时间', '状态', '操作'],
			list: [],
			total: 0, //总条数,
			pageNum: 1,
			pageSize:10,
			novelInfo: {}, //小说信息
			newNumber: null, //最新章节
			isInit: false,//默认false 是初始化，true，不是初始化
			listStatus: true,
			recall: true,//已经开启
		}
	},

	created() {
		this.getUserLoginState(false)
	},
	methods: {
		toBack() {
			sessionStorage.removeItem('editItem')
			this.$router.replace({ path: '/novel' })
		},
		async getChapterList(noveldata, pageNum) {
			console.log(noveldata.id)
			if (!noveldata) return
			this.mixinNovelInfo(noveldata.id, 'lnovel')
			this.novelInfo = noveldata;
			let key = this.getChapterSearchKey(this.lNSeriesSearchKey, this.novelInfo.id)
			const lnSeriesSearch = JSON.parse(localStorage.getItem(key))
			console.log(lnSeriesSearch)
			this.pageNum = lnSeriesSearch?.pageNum || 1
			try {
				if (this.$refs.bottompage) {
					this.$refs.bottompage.page(this.pageNum)
				}

				const res = await lNApi.seriesList({ novelId: noveldata.id, pageNum:this.pageNum,pageSize:this.pageSize });
				if (res.code === 200) {
					if (!res.data) return
					let firstStatus = false;
					// this.total = res.total
					this.list = res.data.map(item => {
						if (!item.hasOutline && !firstStatus) {
							firstStatus = true;
							return { ...item, current: true };
						}
						return { ...item, current: false };
					});
					this.listStatus = res.data && res.data.length > 0 ? true : false
				} else {
					this.$message.warning(res.msg)
				}
			} catch (error) {
				console.error('获取分卷列表出错:', error);
			}
		},
		handleAdd() {
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editType: 2,
				backNum: 2,
				isAiCreate: true,//表示是不是ai生成，ai续写的不算，目的是为了不让别在浏览器复制地址多开当前ai生成页面一直生成问题
			}
			//编辑大纲在novel_list 页面
			sessionStorage.setItem('editItem', JSON.stringify(editItem))
			this.$router.push({ path: '/seriesEditor' });
		},
		//查看分卷
		lookSeries() {
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				editType: 3,
				backNum: 1,
				pageNum: this.pageNum,
				pageSize: 10,
				asc: 'asc'
			}
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/seriesEditor' })
		},
		//查看大纲
		look(item, i) {
			let isShowZG = false
			if (i == 0) {
				isShowZG = item.status == 2 ? false : true
			} else {
				//大于0,每次检查上一个分卷是否已经完成
				let upperItem = this.list[i - 1]
				isShowZG = upperItem.status == 2 && [0, 1].includes(item.status) ? true : false
			}
			if (item.hasOutline) {
				this.$router.push({ path: '/chapterList', query: { seriesInfo: EncryptionUtil.encrypt(item), novelInfo: EncryptionUtil.encrypt(this.novelInfo), isShowZG } })
				return
			}
			let editItem = {
				id: this.novelInfo.id,
				novelInfo: this.novelInfo,
				seriesId: item.id,
				series: item,
				editType: 3,
				backNum: 1,
				isShowZG
			};
			sessionStorage.setItem('editItem', JSON.stringify(editItem));
			this.$router.push({ path: '/seriesChapterEditor' });
		},
		//删除分卷
		del(i, seriesId) {
			let text = ''
			if (i === this.list.length - 1) {
				text = `是否需要删除从第${i + 1}分卷，删除后无法恢复，请慎重操作`
			} else {
				text = `是否需要删除从第${i + 1}分卷到后面所有的分卷，删除后对应的分卷和章节都会删除，且无法恢复，请慎重操作`
			}
			this.$confirm(text, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				//如果当前有id说明是已经存在的，如果没有id说明是刚ai生成的
				// console.log('data=', data)
				lNApi.seriesDel({ id: seriesId }).then(res => {
					if (res.code === 200) {
						this.$message.success('删除成功')
						this.list = this.list.filter((_, index) => index < i) // 从当前索引开始删除所有后续元素
						if (this.list.length === 0) {
							this.$router.replace('/novel');
						}

					} else {
						this.$message.warning(res.msg)
					}
				})

			})

		},
		//清空分卷
		delChatpterAll(item) {
			if (item.status == 2) {
				this.$message.warning('该分卷已完结，不能执行清空操作！！')
				return
			}
			this.$confirm('清空后不可恢复，请谨慎操作。确认要清空该分卷大纲吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				lNApi.delChapter({ seriesId: item.id }).then(res => {
					if (res.code === 200) {
						this.$message.success('清空成功！')
						this.$emit('refreshList')
					}
				})

			})
		},
		//关闭长记忆
		recallChange(e) {
			this.recall = true
			this.$confirm('该作品的长记忆功能一旦关闭将永久失效，且无法再次开启，是否确认关闭?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				api.recallStop({ novelId: this.novelInfo.id, type: 'lnovel' }).then(res => {
					if (res.code === 200) {
						this.$message({
							type: 'success',
							message: '已关闭长记忆功能!'
						});
						this.recall = false
						this.mixinNovelInfo(this.novelInfo.id, 'lnovel')
					} else {
						this.recall = true
						this.$message.warning(res.msg)
					}
				}).catch(_ => {
					this.recall = true
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消关闭长记忆功能'
				});
				this.recall = true
			});
		},
		//分页下一页
		currentNUm(pageNum) {
			this.pageNum = pageNum
			//分页记录缓存
			let key = this.getChapterSearchKey(this.lNSeriesSearchKey, this.novelInfo.id)
			localStorage.setItem(key, JSON.stringify({ pageNum }))
			this.$emit('refreshList')
			
		},
	}
}
</script>

<style lang="scss" scoped>
.novel_chapter1_8 {
	width: 10px;
	height: 10px;
	background: #01CC7A;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_29 {
	width: 10px;
	height: 10px;
	background: #aaa;
	border-radius: 50%;
	margin-right: 5px;
}

.novel_chapter1_30 {
	width: 10px;
	height: 10px;
	background: #548AFF;
	border-radius: 50%;
	margin-right: 5px;
}

.list-btn {
	color: #333333;
}

.btn-icon {
	width: 17px;
	height: 17px;
}

.btn-icon,
.btn-text {
	vertical-align: middle;
	font-family: PingFang SC, PingFang SC;
}

.btn-text {
	margin-left: 2px;
}

.info-right {
	float: right;
	padding-right: 1%;
}

.apart-title {
	// padding-top: 20px;
	padding-bottom: 20px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 800;
	font-size: 17px;
	color: #111111;
	line-height: 17px;
	display: flex;
	justify-content: space-between;
}

.apart-info {
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #FF8E0D;
	line-height: 17px;
	text-align: left;
	font-style: normal;
	text-transform: none;
}

.apart-item {
	margin: 0 25px;
	padding: 20px 0;
	// height: 206px;
	position: relative;

	&:last-child{
	  &::before{
	    height: 0 !important;
	  }
	}
	&::before {
		content: " ";
		position: absolute;
		bottom: 0;
		height: 1px;
		width: 100%;
		background-color: #E6EBF0;
	}
}

.empty-list {
	width: 100%;
	height: 92%;
	background-color: #FFFFFF;
	display: flex;
	flex-direction: column;
	/* 子元素垂直排列 */
	justify-content: center;
	/* 整体垂直居中 */
	align-items: center;
}

.add-btn:hover {
	color: var(--tech-primary);
	cursor: pointer;
}

.list-btn:hover {
	color: var(--tech-primary);
}

.add-text {
	line-height: 1;
	vertical-align: middle;
}

.add-icon {
	display: inline-block;
	vertical-align: middle;
}

.add-btn {
	height: 100%;
	font-size: 16px;
	display: flex;
	align-items: center;
}

.apart-list {
	width: 100%;
	flex: 1;
	background-color: #FFFFFF;
	overflow: auto;
	@include no_scrollbar();

}

.apart-top {
	width: 100%;
	height: 77px;
	background-color: #FFFFFF;
	position: relative;
	flex-shrink: 0;

	&::before {
		content: " ";
		position: absolute;
		bottom: 0;
		height: 1px;
		width: 100%;
		background-color: #E6EBF0;
	}

	.back-img {
		display: block;
		margin-top: 2px;
	}

	.apart-top-title {
		height: 19px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: bold;
		font-size: 19px;
		color: #111111;
		line-height: 19px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-left: 4px;
	}
}

#apart_main {
	width: 100%;
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
}
.apart_main_top{
	box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
	border-radius: 10px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	height: auto;
	width: auto;
	margin-bottom: 15px;
}
</style>
<style lang="scss" scoped>
::v-deep .clearPadding .vxe-cell {
	padding: 0;
}

::v-deep .clearPaddingLeft .vxe-cell {
	padding-left: 0px;
}

::v-deep {
	.main-el-switch {
		position: relative;

		.el-switch__core {
			height: 40px;
			border-radius: 20px;

			&:after {
				left: 3px;
				top: 3px;
				height: 32px;
				width: 32px;
			}
		}

		&.el-switch {
			height: 40px;
			line-height: 40px;

			&.is-checked {
				.el-switch__core {
					&:after {
						margin-left: -35px;
						left: 100%;
					}
				}
			}
		}

		&.is-checked {
			.el-switch__label--left {
				opacity: 0;
			}

			.el-switch__label--right {
				opacity: 1;
			}
		}

		.el-switch__label {
			position: absolute;
			top: 0;
		}

		.el-switch__label--left {
			right: 0;
			color: #999;
			z-index: 1;
			margin-right: 8px;
		}

		.el-switch__label--right {
			left: 0;
			color: #fff;
			opacity: 0;
			margin-left: 8px;
		}
	}
}
</style>